import { createStorefrontApiClient } from '@shopify/storefront-api-client';
import { PUBLIC_TOKEN, URL } from '../shopify-public-key.js';

// Create the Shopify client
const client = createStorefrontApiClient({
  storeDomain: URL,
  apiVersion: '2025-07',
  publicAccessToken: PUBLIC_TOKEN,
});

// Export the client for use throughout the application
export { client };